// @owners { team: patients }
export const USE_SOMETHING_ELSE_LABEL = 'Use something else';
